/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ApiDashboardProfilePayloadToJSON, ApiDashboardProfileResponseFromJSON, ApiListDashboardProfilesResponseFromJSON, ApiUserDashboardProfileFromJSON, ApiUserDashboardProfilePayloadToJSON, } from '../models';
/**
 *
 */
export class DashboardServiceApi extends runtime.BaseAPI {
    /**
     */
    dashboardServiceCreateDashboardProfileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling dashboardServiceCreateDashboardProfile.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling dashboardServiceCreateDashboardProfile.');
            }
            const queryParameters = {};
            if (requestParameters.dashboardProfileId !== undefined) {
                queryParameters['dashboardProfileId'] = requestParameters.dashboardProfileId;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/dashboard/v1/projects/{projectId}/profiles`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiDashboardProfilePayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiDashboardProfileResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    dashboardServiceCreateDashboardProfile(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardServiceCreateDashboardProfileRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    dashboardServiceDeleteDashboardProfileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling dashboardServiceDeleteDashboardProfile.');
            }
            if (requestParameters.dashboardProfileId === null || requestParameters.dashboardProfileId === undefined) {
                throw new runtime.RequiredError('dashboardProfileId', 'Required parameter requestParameters.dashboardProfileId was null or undefined when calling dashboardServiceDeleteDashboardProfile.');
            }
            const queryParameters = {};
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadReportIds) {
                queryParameters['payload.reportIds'] = requestParameters.payloadReportIds;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/dashboard/v1/projects/{projectId}/profiles/{dashboardProfileId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"dashboardProfileId"}}`, encodeURIComponent(String(requestParameters.dashboardProfileId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    dashboardServiceDeleteDashboardProfile(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardServiceDeleteDashboardProfileRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns the calling user\'s selected profile for the project (empty defaults if unset).
     */
    dashboardServiceGetUserDashboardProfileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling dashboardServiceGetUserDashboardProfile.');
            }
            const queryParameters = {};
            if (requestParameters.payloadDashboardProfileId !== undefined) {
                queryParameters['payload.dashboardProfileId'] = requestParameters.payloadDashboardProfileId;
            }
            if (requestParameters.payloadPresetKey !== undefined) {
                queryParameters['payload.presetKey'] = requestParameters.payloadPresetKey;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/dashboard/v1/projects/{projectId}/user-profile`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiUserDashboardProfileFromJSON(jsonValue));
        });
    }
    /**
     * Returns the calling user\'s selected profile for the project (empty defaults if unset).
     */
    dashboardServiceGetUserDashboardProfile(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardServiceGetUserDashboardProfileRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    dashboardServiceListDashboardProfilesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling dashboardServiceListDashboardProfiles.');
            }
            const queryParameters = {};
            if (requestParameters.dashboardProfileId !== undefined) {
                queryParameters['dashboardProfileId'] = requestParameters.dashboardProfileId;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadReportIds) {
                queryParameters['payload.reportIds'] = requestParameters.payloadReportIds;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/dashboard/v1/projects/{projectId}/profiles`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListDashboardProfilesResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    dashboardServiceListDashboardProfiles(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardServiceListDashboardProfilesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    dashboardServiceReadDashboardProfileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling dashboardServiceReadDashboardProfile.');
            }
            if (requestParameters.dashboardProfileId === null || requestParameters.dashboardProfileId === undefined) {
                throw new runtime.RequiredError('dashboardProfileId', 'Required parameter requestParameters.dashboardProfileId was null or undefined when calling dashboardServiceReadDashboardProfile.');
            }
            const queryParameters = {};
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadReportIds) {
                queryParameters['payload.reportIds'] = requestParameters.payloadReportIds;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/dashboard/v1/projects/{projectId}/profiles/{dashboardProfileId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"dashboardProfileId"}}`, encodeURIComponent(String(requestParameters.dashboardProfileId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiDashboardProfileResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    dashboardServiceReadDashboardProfile(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardServiceReadDashboardProfileRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    dashboardServiceSetUserDashboardProfileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling dashboardServiceSetUserDashboardProfile.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling dashboardServiceSetUserDashboardProfile.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/dashboard/v1/projects/{projectId}/user-profile`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ApiUserDashboardProfilePayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiUserDashboardProfileFromJSON(jsonValue));
        });
    }
    /**
     */
    dashboardServiceSetUserDashboardProfile(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardServiceSetUserDashboardProfileRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    dashboardServiceUpdateDashboardProfileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling dashboardServiceUpdateDashboardProfile.');
            }
            if (requestParameters.dashboardProfileId === null || requestParameters.dashboardProfileId === undefined) {
                throw new runtime.RequiredError('dashboardProfileId', 'Required parameter requestParameters.dashboardProfileId was null or undefined when calling dashboardServiceUpdateDashboardProfile.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling dashboardServiceUpdateDashboardProfile.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/dashboard/v1/projects/{projectId}/profiles/{dashboardProfileId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"dashboardProfileId"}}`, encodeURIComponent(String(requestParameters.dashboardProfileId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: ApiDashboardProfilePayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiDashboardProfileResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    dashboardServiceUpdateDashboardProfile(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dashboardServiceUpdateDashboardProfileRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
